<template>
  <div class="about-us">
    <about-us-top-block />
    <about-us-goal />
    <about-us-mission />
    <about-us-values />
    <about-us-our-products />
    <about-us-our-careers />
    <!-- <about-us-our-team /> -->
    <!-- bg-class="bg--color-01" -->
    <subscribe-block bg-class="bg--color-10" />
  </div>
</template>

<script>
import { getDefaultHeadData } from '@/lib/utils'

export default {
  name: 'AboutUs',
  components: {
    AboutUsTopBlock: () => import('@/components/about-us/AboutUsTopBlock.vue'),
    AboutUsGoal: () => import('@/components/about-us/AboutUsGoal.vue'),
    AboutUsMission: () => import('@/components/about-us/AboutUsMission.vue'),
    AboutUsValues: () => import('@/components/about-us/AboutUsValues.vue'),
    AboutUsOurProducts: () =>
      import('@/components/about-us/AboutUsOurProducts.vue'),
    AboutUsOurCareers: () =>
      import('@/components/about-us/AboutUsOurCareers.vue'),
    // AboutUsOurTeam: () => import('@/components/about-us/AboutUsOurTeam.vue'),
    SubscribeBlock: () => import('@/components/welcome/SubscribeBlock.vue'),
  },
  head () {
    return getDefaultHeadData({
      title: this.$t('meta.aboutUs.title'),
      description: this.$t('meta.aboutUs.description'),
      locale: this.$i18n.locale,
    })
  },
}
</script>

<style lang="scss" scoped>
.about-us {
  // &__goal {
  //   margin-top: toRem(-20px);

  //   @include bp(l) {
  //     margin-top: toRem(-60px);
  //   }
  // }

  // &__mission {
  //   margin-top: toRem(-20px);

  //   @include bp(l) {
  //     margin-top: toRem(-60px);
  //   }
  // }
}
</style>
